/**
 *
 * Asynchronously loads the component for ForgotPasswordFormV2
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { Loading } from 'components/Loading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "ForgotPasswordFormV2" */),
  loading: <Loading />
})
